import Vue from 'vue'
import Vuex from 'vuex'
import addbuy from './modules/addBuy'
import newbuy from './modules/newBuy'
import renewbuy from './modules/renewBuy'
import Order from './modules/Order'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        subnav: [],
        yunVarity: [],
        lessonVarity: [],
        orderInfo: null,
        otherOrderId: '',
        globalTabType: '',
        curTabInstance: null,
        seats: '',
        wh10ClientAccount: '',
        isclient: false, //todo: 用于判断是否是客户端通过url访问进来的
        payOk: false, //用于判断上一次或者正在进行的支付环节是否成功
        pImgUrlList: [],
        softUrl: null
    },
    mutations: {
        setOrderInfo(state, payload) {
            state.orderInfo = payload
        },
        setOtherId (state, payload) {
            state.otherOrderId = payload
        },
        setSubNav(state, payload) {
            state.subnav = payload
        },
        setSeats (state,val) {
            state.seats = val
        },
        setYunVarity(state, payload) {
            state.yunVarity = payload
        },
        setLessonVarity(state, payload) {
            state.lessonVarity = payload
        },
        setGlobalTabType (state,val) {
            state.globalTabType = val
        },
        setTabInstance (state,val) {
            state.curTabInstance = val
        },
        setWh10ClientAccount(state,val) {
            state.wh10ClientAccount = val
        },
        setIsClient (state,val) {
            state.isclient = val
        },
        setPayState (state, val) {
            state.payOk = val
        },
        setPic(state, payload) {
            state.pImgUrlList = payload
        },
        setProductAddress(state, payload) {
            state.softUrl = payload
        },
    },
    getters: {
        subnavNames(state) {
            var arr = []
            for (let i = 0; i < state.subnav.length; i++) {
                let v = state.subnav[i]
                if (typeof v == 'string') {
                    arr.push(v)
                } else {
                    arr.push(v.name)
                    if (!v.isShow) break
                }
            }
            return arr
        },
        getPic(state) {
            return state.pImgUrlList
        },
        getProductAddress(state) {
            return state.softUrl
        }
    },
    actions: {},
    modules: {
        addbuy,
        newbuy,
        renewbuy,
        Order,
    }
})